import React, { useState } from "react";
import { API_URL } from "../../api-config";

const CreateBlogPost = () => {
  const [formData, setFormData] = useState({
    text1: "",
    text2: "",
  });
  const [image1, setImage1] = useState(null); // Archivo para la imagen 1
  const [image2, setImage2] = useState(null); // Archivo para la imagen 2
  const [preview1, setPreview1] = useState(null); // Vista previa de imagen 1
  const [preview2, setPreview2] = useState(null); // Vista previa de imagen 2

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageUpload = (e, setImage, setPreview) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file); // Guarda el archivo en el estado
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl); // Muestra la vista previa
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("text_1", formData.text1);
    formDataToSend.append("text_2", formData.text2);
    formDataToSend.append("image_1", image1); // Archivo de imagen 1
    formDataToSend.append("image_2", image2); // Archivo de imagen 2

    try {
      const response = await fetch(`${API_URL}/trading-api/charts/create_post`, {
        method: "POST",
        body: formDataToSend,
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Post creado:", data);
      alert("¡Post creado con éxito!");

      // Reinicia el formulario
      setFormData({ text1: "", text2: "" });
      setImage1(null);
      setImage2(null);
      setPreview1(null);
      setPreview2(null);
    } catch (error) {
      console.error("Error al crear el post:", error);
      alert("Hubo un error al crear el post. Intenta nuevamente.");
    }
  };

  return (
    <div className="flex inset-0 bg-opacity-50 flex h-fit items-center justify-center">
      <div className="bg-transparent w-4/5 h-4/5 rounded-lg shadow-lg overflow-hidden">
        <h1 className="text-2xl font-bold text-center py-4 bg-gray-800 text-white">
          Crear Nuevo Post
        </h1>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-2 gap-4 p-6 h-[calc(100%-4rem)]"
        >
          {/* Sección Izquierda - Imágenes */}
          <div className="flex flex-col gap-4">
            {/* Imagen 1 */}
            <div>
              <label
                htmlFor="image1"
                className="block text-sm font-medium mb-2"
              >
                Imagen 1
              </label>
              <input
                type="file"
                accept="image/*"
                id="image1"
                onChange={(e) => handleImageUpload(e, setImage1, setPreview1)}
                className="w-full border rounded-lg p-2"
                required
              />
              {preview1 && (
                <img
                  src={preview1}
                  alt="Vista previa 1"
                  className="mt-2 w-full h-fit object-cover rounded-lg border"
                />
              )}
            </div>
            {/* Imagen 2 */}
            <div>
              <label
                htmlFor="image2"
                className="block text-sm font-medium mb-2"
              >
                Imagen 2
              </label>
              <input
                type="file"
                accept="image/*"
                id="image2"
                onChange={(e) => handleImageUpload(e, setImage2, setPreview2)}
                className="w-full border rounded-lg p-2"
                required
              />
              {preview2 && (
                <img
                  src={preview2}
                  alt="Vista previa 2"
                  className="mt-2 w-full h-fit object-cover rounded-lg border"
                />
              )}
            </div>
          </div>

          {/* Sección Derecha - Textos */}
          <div className="flex flex-col gap-4">
            {/* Texto 1 */}
            <div>
              <label htmlFor="text1" className="block text-sm font-medium mb-2">
                Texto 1
              </label>
              <textarea
                id="text1"
                name="text1"
                value={formData.text1}
                onChange={handleInputChange}
                placeholder="Escribe el texto 1 aquí..."
                className="w-full border rounded-lg p-2 h-64 text-black"
                required
              ></textarea>
            </div>
            {/* Texto 2 */}
            <div>
              <label htmlFor="text2" className="block text-sm font-medium mb-2">
                Texto 2
              </label>
              <textarea
                id="text2"
                name="text2"
                value={formData.text2}
                onChange={handleInputChange}
                placeholder="Escribe el texto 2 aquí..."
                className="w-full border rounded-lg p-2 h-64 text-black"
                required
              ></textarea>
            </div>
          </div>

          {/* Botón de Envío */}
          <div className="col-span-2 flex justify-end">
            <button
              type="submit"
              className="bg-green-500 h-12 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition"
            >
              Crear Post
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateBlogPost;
